/**
 * EcoF-Video-Player
 * Handles thumbnail switching and play overlay for native videos.
 */

(function() {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function initVideoPlayer(section) {
    var mainStages = section.querySelectorAll('[data-ecof-video-stage]');
    var thumbs = section.querySelectorAll('[data-ecof-video-thumb]');

    if (mainStages.length === 0 || thumbs.length === 0) return;

    // Thumbnail click switches the main stage
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var targetIndex = thumb.getAttribute('data-ecof-video-thumb');

        // Update stages
        mainStages.forEach(function(stage) {
          if (stage.getAttribute('data-ecof-video-stage') === targetIndex) {
            stage.classList.add('is-active');
            // Auto-play native videos in the active stage
            var videos = stage.querySelectorAll('video');
            videos.forEach(function(video) {
              video.play().catch(function(err) {
                console.log('EcoF-Video-Player autoplay prevented:', err);
              });
            });
          } else {
            stage.classList.remove('is-active');
            // Pause native videos in inactive stages
            var videos = stage.querySelectorAll('video');
            videos.forEach(function(video) {
              video.pause();
            });
          }
        });

        // Update active thumb
        thumbs.forEach(function(t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });

    // Play overlay for native videos
    mainStages.forEach(function(stage) {
      var video = stage.querySelector('video');
      var overlay = stage.querySelector('.ecof-video-player__play-overlay');

      if (!video || !overlay) return;

      function updateOverlay() {
        if (video.paused || video.ended) {
          overlay.classList.remove('is-hidden');
        } else {
          overlay.classList.add('is-hidden');
        }
      }

      overlay.addEventListener('click', function() {
        if (video.paused || video.ended) {
          video.play();
        } else {
          video.pause();
        }
      });

      video.addEventListener('play', updateOverlay);
      video.addEventListener('pause', updateOverlay);
      video.addEventListener('ended', updateOverlay);

      // Initial state
      updateOverlay();
    });
  }

  ready(function() {
    var sections = document.querySelectorAll('[data-section-type="ecof-video-player"]');
    sections.forEach(function(section) {
      initVideoPlayer(section);
    });
  });
})();
